import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '@styled-system/css';
import { useToast, ToastContext } from '../toast/ToastContext.js';
import { ToastManager } from '../toast/ToastManager.js';
import React__default from 'react';
import { createGlobalStyle } from 'styled-components';
import { IconFontStyle } from '../../styles/IconFontStyle.js';
import { MatterStyle } from '../../styles/MatterStyle.js';
import { ResetStyle } from '../../styles/ResetStyle.js';
import { useColorMode, ColorModeContext } from './ColorModeContext.js';
import { useWindowSize, WindowSizeContext } from './WindowSizeContext.js';
import { YoungThemeProvider } from './YoungThemeProvider.js';

var GlobalStyle = createGlobalStyle(css({
    "*": {
        fontFamily: "matter",
        fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss04' on",
    },
    body: {
        color: "textPrimary",
    },
}));
var YoungProvider = function (_a) {
    var children = _a.children, options = _a.options;
    var windowSize = useWindowSize();
    var toast = useToast();
    var colorMode = useColorMode(__assign({}, options === null || options === void 0 ? void 0 : options.colorMode));
    return (React__default.createElement(ColorModeContext.Provider, { value: colorMode },
        React__default.createElement(YoungThemeProvider, { colorMode: colorMode.colorMode },
            React__default.createElement(WindowSizeContext.Provider, { value: windowSize },
                React__default.createElement(ToastContext.Provider, { value: toast },
                    React__default.createElement(MatterStyle, null),
                    React__default.createElement(IconFontStyle, null),
                    React__default.createElement(GlobalStyle, null),
                    React__default.createElement(ResetStyle, null),
                    children,
                    React__default.createElement(ToastManager, __assign({}, options === null || options === void 0 ? void 0 : options.toast)))))));
};

export { YoungProvider };
//# sourceMappingURL=YoungProvider.js.map
